// MOCK DATA ONLY (frontend-only teaser). Backend integration will replace this later.

export const MOCK = {
  home: {
    hero: {
      headline: "The Speed of Reality.",
      subheadline:
        "The world’s first Zero-Latency Analog AR Platform. Moving light directly, not data.",
      badges: ["<1ms latency", "Physics-first AR", "Patent Pending"],
    },
    ip: [
      {
        title: "Optical Path Architecture",
        patent: "US Patent Pending 63/956,009",
        desc: "Lens-to-display optical topology designed for analog-direct transmission.",
      },
      {
        title: "Zero-Latency Transmission",
        patent: "US Patent Pending 63/970,453",
        desc: "Deterministic, non-buffered signal path engineered for sub-millisecond response.",
      },
      {
        title: "Hardware-Level Privacy Control",
        patent: "US Patent Pending 63/976,067",
        desc: "Physical controls that constrain capture and telemetry at the hardware boundary.",
      },
      {
        title: "Cognitive Layer",
        patent: "US Patent Pending 64/010,067",
        desc: "Decoupled, opt-in augmentation channel that cannot slow the primary analog feed.",
      },
    ],
    privacy: {
      features: [
        "Air-gapped by design",
        "Physical privacy switch",
        "Thermal-optimized enclosure",
      ],
    },
    faq: [
      {
        q: "What does “<1ms” mean in practice?",
        a: "It’s a physics-first latency target for the analog-direct optical path—measured as transmission delay, not a camera/video pipeline delay.",
      },
      {
        q: "Is VOKU cloud-dependent?",
        a: "No. The core platform is designed to operate offline without cloud accounts, buffering, or data logging.",
      },
      {
        q: "How should I evaluate VOKU?",
        a: "Start with the technology section, review the IP portfolio, then choose an application track (Vision or Link) for next steps.",
      },
    ],
    footer: {
      left: "VOKU Technologies Inc. | Est. 2026, Florida, USA.",
    },
  },
};
